<template>
	<div>
		<el-card class="box-card">
			<div slot="header" style="display: flex;" class="clearfix">
				<div style="width: 80px;margin-right: 200px;">
					<span class="header_s"></span>
					<span class="headers" v-if="$route.query.key == 1">活动统计</span>
					<span class="headers" v-else>活动详情</span>
				</div>
				<div class="text item">
					<span style="display: inline-block;margin-right: 20px;"
						>活动参与人数:
						<span style="color: red;">{{ form.participants_num }}</span>
						人</span
					>
					<span style="display: inline-block;margin-right: 20px;"
						>活动中奖人数:
						<span style="color: red;">{{ form.winners_num }}</span> 人</span
					>
					<span style="display: inline-block;margin-right: 20px;"
						>活动分享人数:
						<span style="color: red;">{{ form.share_num }}</span> 人</span
					>
					<span style="display: inline-block;margin-right: 20px;"
						>浏览量:
						<span style="color: red;">{{ form.views || 0 }}</span></span
					>
				</div>
			</div>
			<el-row :gutter="10">
				<el-col :span="10">
					<el-form label-width="120px">
						<el-form-item label="活动名称 :">
							<span>{{ form.prize_name }}</span>
							<template v-if="$route.query.key !== 1">
								<el-popover
									placement="top"
									width="180"
									trigger="manual"
									v-model="visible3"
								>
									<el-input
										size="small"
										style="width: 100%;"
										v-model="edit.prize_name"
										placeholder="活动名称"
									></el-input>

									<div style="text-align: right; margin-top: 10px;">
										<el-button size="mini" type="text" @click="visible3 = false"
											>取消</el-button
										>
										<el-button
											type="primary"
											size="mini"
											@click="editCredit"
											>确定</el-button
										>
									</div>
									<el-button
										slot="reference"
										style="margin-left: 5px;"
										class="edit"
										size="mini"
										circle
										icon="el-icon-edit"
										@click="visible3 = true"
									></el-button>
								</el-popover>
							</template>
							<!-- <el-button type="primary" icon="el-icon-edit" circle></el-button> -->
						</el-form-item>
						<el-form-item label="参与群体 :">
							<div>{{ form.population_type }}</div>
						</el-form-item>
						<el-form-item label="活动开始时间 :">
							<span>{{ form.start_time }}</span>
							<template v-if="$route.query.key !== 1">
								<el-popover
									placement="top"
									width="260"
									trigger="manual"
									v-model="visible2"
								>
									<el-date-picker
										size="small"
										type="datetime"
										placeholder="开始日期"
										v-model="edit.start_time"
										value-format="yyyy-MM-dd HH:mm:ss"
										style="width: 100%;"
									></el-date-picker>
									<div style="text-align: right; margin-top: 10px;">
										<el-button size="mini" type="text" @click="edit.start_time = '' , visible2 = false"
											>取消</el-button
										>
										<el-button
											type="primary"
											size="mini"
											@click="editCredit"
											>确定</el-button
										>
									</div>
									<el-button
										slot="reference"
										style="margin-left: 5px;"
										class="edit"
										size="mini"
										circle
										icon="el-icon-edit"
										@click="visible2 = true"
									></el-button>
								</el-popover>
							</template>
						</el-form-item>
						<el-form-item label="活动结束时间 :">
							<span>{{ form.end_time }}</span>
							<template v-if="$route.query.key !== 1">
								<el-popover
									placement="top"
									width="260"
									trigger="manual"
									v-model="visible1"
								>
									<el-date-picker
										size="small"
										type="datetime"
										placeholder="结束日期"
										v-model="edit.end_time"
										value-format="yyyy-MM-dd HH:mm:ss"
										style="width: 100%;"
									></el-date-picker>
									<div style="text-align: right; margin-top: 10px;">
										<el-button size="mini" type="text" @click="visible1 = false"
											>取消</el-button
										>
										<el-button
											type="primary"
											size="mini"
											@click="editCredit"
											>确定</el-button
										>
									</div>
									<el-button
										slot="reference"
										style="margin-left: 5px;"
										class="edit"
										size="mini"
										circle
										icon="el-icon-edit"
										@click="visible1 = true"
									></el-button>
								</el-popover>
							</template>
							<!-- <el-button style="width: 20px;height: 20px;text-aling:center;" type="primary" icon="el-icon-edit" circle></el-button> -->
						</el-form-item>
						<el-form-item label="活动标语 :">
							<div>{{ form.slogan }}</div>
						</el-form-item>
						<el-form-item label="活动规则 :">
							<div style="width: 100%;">{{ form.intro }}</div>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="2">
					<div class="context"></div>
				</el-col>

				<el-col :span="12">
					<el-table :data="form.awards" style="width: 100%">
						<el-table-column prop="award_name" label="奖品名">
						</el-table-column>
						<el-table-column prop="pic_url" label="图片">
							<template slot-scope="scope">
								<img style="width: 30px;" :src="scope.row.pic_url" alt="" />
							</template>
						</el-table-column>
						<div v-if="$route.query.key == 1">
							<el-table-column prop="award_collected_num" label="已中奖">
							</el-table-column>
							<el-table-column prop="stock" label="剩余"> </el-table-column>
							<el-table-column prop="award_consumed_num" label="已核销">
							</el-table-column>
						</div>
						<div v-else>
							<el-table-column prop="award_collected_num" label="类型">
								<template slot-scope="scope">
									<div
										v-text="
											scope.row.award_type == 1
												? '优惠券'
												: scope.row.award_type == 2
												? '积分'
												: scope.row.award_type == 3
												? '实物'
												: scope.row.award_type == 4
												? '余额'
												: '谢谢参与'
										"
									></div>
								</template>
							</el-table-column>
							<el-table-column prop="rate" label="奖品概率"> </el-table-column>
							<el-table-column prop="stock" label="奖品数量"> </el-table-column>
						</div>
					</el-table>
				</el-col>
			</el-row>
		</el-card>
	</div>
</template>
<script>
import { edit_baseinfo, lottery_detail } from "@/api/vip";
import store from "@/store/index";

export default {
	data() {
		return {
			form: {},
			visible1: false,
			visible2: false,
			visible3: false,
			edit: {},
		};
	},
	mounted() {
		this.lottery_info();
	},
	methods: {
		//修改信息
		async editCredit() {
      let data = {
        app_id:store.getters.app_id,
        id: this.$route.query.id,
        ...this.edit
      }
			const res = await edit_baseinfo(data);
      if(res.code == 200){
        this.$message.success(res.msg)
        this.visible1 = false
        this.visible2 = false
        this.visible3 = false
        this.lottery_info()
      }else{
        this.$message.error(res.msg)
      }

		},
		async lottery_info() {
			try {
				const res = await lottery_detail({
					app_id: store.getters.app_id,
					id: this.$route.query.id,
				});
				if (res.code == 200) {
					this.form = res.data;
					
					switch (res.data.population_type) {
						case "1":
							res.data.population_type = "所有线上用户";
							break;
						case "2":
							break;
						case "3":
							res.data.population_type = "所选会员等级下的所有用户";
							break;
						case "4":
							res.data.population_type = "所选会员标签下的所有用户";
							break;
						default:
							break;
					}

					this.form = res.data;
				} else {
					this.$message.error(res.msg);
				}
			} catch (e) {
				console.log(e);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.text {
	font-size: 14px;
}

.item {
	width: 100%;
	height: 100%;
	float: right;
}
.clearfix:before,
.clearfix:after {
	display: table;
	content: "";
}
.clearfix:after {
	clear: both;
}
.box-card {
	width: 100%;
	.header_s {
		display: block;
		width: 5px;
		height: 20px;
		float: left;
		background-color: aqua;
	}
	.headers {
		display: block;
		float: right;
		height: 20px;
		line-height: 20px;
		font-size: 1.2em;
	}
	.context {
		width: 100%;
		height: 35vw;
		border-right: 1px solid #cccccc;
	}
}
</style>
